import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Parent, ParentConsent } from 'backend/interfaces/parent.interface';
import { Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatStepper, StepperOrientation } from '@angular/material/stepper';
import { map, startWith } from 'rxjs/operators';
import { ParentService } from 'src/app/admin/services/parent.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from "moment";
import { DataService } from 'src/app/services/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { cities } from '../business-profile/business-profile.component';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @Input() profile: Parent = {
    Name: '',
    Surname: '',
    ID: '',
    Occupation: '',
    Title: '',
    Gender: '',
    Address: '',
    City: '',
    Mobile: '',
    Email: this.parentService.newParentEmail ? this.parentService.newParentEmail : '',
    HealthProblems: '',
    Notes: '',
    MedicalAidName: '',
    MedicalAidNumber: '',
    MedicalAidMainMember: '',
    isMainContact: false,
    PartnerID: '',
  };
  saving = false;
  confirmingDeletion = false;
  requestingDeletion = false;
  deletionRequestedAt: Date;
  deletionError = '';
  deletionConfirmation = this.fb.control('');
  @Output() emitProfile: EventEmitter<any> = new EventEmitter();
  @Output() emitMedical = new EventEmitter<Object>();
  @ViewChild('stepper') private stepper: MatStepper;
  filteredCities: Observable<object[]>;
  constructor(private dataService: DataService, private fb: UntypedFormBuilder, private breakpointObserver: BreakpointObserver, private parentService: ParentService, private router: Router, private _snackBar: MatSnackBar, private authService: AuthService) {
    this.stepperOrientation = breakpointObserver.observe('(min-width: 800px)')
      .pipe(map(({ matches }) => matches ? 'horizontal' : 'vertical'));
  }
  profileForm: UntypedFormGroup;
  // medicalForm: UntypedFormGroup;
  thirdFormGroup = this.fb.group({
    thirdCtrl: ['', Validators.required]
  });
  stepperOrientation: Observable<StepperOrientation>;
  async ngOnInit(): Promise<void> {
    this.authService.$User.subscribe(async (res) => {
      if (res) {
        this.deletionRequestedAt = res.get('accountDeletionRequestedAt');
        this.profile = {
          Name: res.get('Name'),
          Surname: res.get('Surname'),
          ID: res.get('ID'),
          City: res.get('City'),
          Address: res.get('Address'),
          Mobile: res.get('Mobile'),
          Email: res.get('email')
        }
      }
    });

    this.profileForm = this.fb.group({
      Name: [this.profile.Name, Validators.required],
      Surname: [this.profile.Surname],
      ID: [this.profile.ID, Validators.length > 10],
      Address: [this.profile.Address],
      City: [this.profile.City],
      Mobile: [this.profile.Mobile],
      Email: [this.profile.Email, Validators.required]
    })

    this.filteredCities = this.profileForm.controls['City'].valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
  }
  async saveProfile() {
    if (this.profileForm.dirty) {
      this.saving = true;
      // const parentID = this.profileForm.controls['ID'].value;
      // let DOB = '';
      // const mm = parentID.substring(0,2)
      // const dd = parentID.substring(2,4)
      // const yy = parentID.substring(4,6)
      // if(parentID.length > 10){
      //   DOB = moment(new Date(mm+'/'+dd+'/'+yy)).format('MMM DD yyyy')
      //   console.log(DOB)
      // }
      // this.profileForm.controls['PartnerID'].patchValue(!this.profileForm.controls['hasPartner'].value ? '' : this.profileForm.controls['PartnerID'].value)
      this.dataService.saveUser({ ...this.profileForm.value })
        .then((res) => {
          this.parentService.newParentEmail = undefined;
          this.openSnackBar('Profile saved');
          // this.stepper.next();
          this.parentService.getParentCount();
          this.saving = false
        })
        .catch((err) => {
          this.openSnackBar(err);
          this.saving = false;
        });
      this.profileForm.markAsPristine();
      this.profile.ID = this.profileForm.controls['ID'].value;
    } else {
      // this.stepper.next();
    }
  }
  cancelDeletion(): void {
    if (this.requestingDeletion) return;
    this.confirmingDeletion = false;
    this.deletionConfirmation.reset('');
    this.deletionError = '';
  }

  async requestAccountDeletion(): Promise<void> {
    if (this.requestingDeletion || this.deletionRequestedAt || this.deletionConfirmation.value !== 'DELETE') return;
    this.requestingDeletion = true;
    this.deletionError = '';
    try {
      const result = await this.authService.requestAccountDeletion(this.deletionConfirmation.value);
      this.deletionRequestedAt = new Date(result.requestedAt);
      this.confirmingDeletion = false;
      this.deletionConfirmation.reset('');
    } catch (error) {
      this.deletionError = 'Your deletion request could not be confirmed. Please try again. If your session has expired, sign in again.';
    } finally {
      this.requestingDeletion = false;
    }
  }
  // async saveMedicalDetails(){
  //   if(this.medicalForm.dirty){
  //     this.saving = true;
  //     const medicalForm = {...this.medicalForm.value, 
  //       ID: this.profile.ID};

  //       this.parentService
  //       .saveParentMedicalDetails(medicalForm)
  //       .then(() => {
  //         this.openSnackBar('Medical details saved');
  //         this.saving = false;
  //         this.stepper.next();
  //       })
  //       .catch((err) => {
  //         this.openSnackBar(err);
  //         this.saving = false;
  //       });
  //     this.medicalForm.markAsPristine();
  //   } else {
  //     this.stepper.next();
  //   }
  // }
  getErrorMessage() {
    if (this.profileForm.controls['Name'].hasError('required')) {
      return 'You must enter a value';
    }

    return this.profileForm.controls['Name'].hasError('required') ? 'Not a valid name' : '';
  }

  async saveParentConsent(event: { student: ParentConsent, signature: string }) {
    this.saving = true;
    this.parentService
      .saveParentConsent(event.student)
      .then(() => {
        this.openSnackBar('Consent saved');
        this.emitProfile.emit(event.student);
        this.saving = false;
      })
      .catch((err) => {
        this.openSnackBar(err);
        this.saving = false;
      });
  }


  back() {
    this.stepper.previous();
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, 'OK', {
      duration: 3000
    });
  }
  private _filter(value: string): object[] {
    const filterValue = value.toLowerCase();

    return cities.filter(option => option.city.toLowerCase().includes(filterValue));
  }
}


